import { render, staticRenderFns } from "./NovosArquivos.vue?vue&type=template&id=2c04c207&scoped=true"
import script from "./NovosArquivos.vue?vue&type=script&lang=js"
export * from "./NovosArquivos.vue?vue&type=script&lang=js"
import style0 from "./NovosArquivos.vue?vue&type=style&index=0&id=2c04c207&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c04c207",
  null
  
)

export default component.exports